import React from 'react'
import { Col, Form, FormGroup, Label, Input } from 'reactstrap';

export const FormTinsion = (props) => {

    const { handleInputChange, name } = props;

    return (
        <Form className="" role="form" >

            <Col md="12">
                <FormGroup>
                    <Label className="col-form-label">Tinsion <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        type="text"
                        className="form-control form-control-sm input-air-primary"
                        name="name"
                        onChange={handleInputChange}
                        value={name}
                        autoComplete="off"
                    />
                </FormGroup>
            </Col>


        </Form>
    )
}
